<template>
  <div id="cookieNotice" v-if="snackbar">
    <div id="cookieNoticeInner">
      Usamos cookies para asegurar que te damos la mejor experiencia en nuestra web. <br>
      
        
          <label for="checkCokies">
            
          He leído y acepto la política de <a href="/protecciondatos">Protección de Datos</a> y el uso de <a href="#/cookies">Cookies</a>.
          <input type="checkbox" @click="acceptCookies()" v-model="check" name="checkCokies">
          </label>
      
        <button
          class="btn btn-block btn-default "
          text
          elevation="3"
          @click="acceptCookies()"
        >
          Aceptar
        </button>

    </div>
  </div>
</template>
<script>
export default {
  name:"CookieNotice",
  data: () => ({
    snackbar: true,
    check:false
  }),
  created(){
    var acceptCookies = this.$cookie.get("acceptCookies");
    if(acceptCookies)
      this.snackbar = false
  },  
  methods: {
    acceptCookies(){
      this.snackbar = false
      this.$cookie.set("acceptCookies", true, 30)
    }
  },
}
</script>
<style >

#cookieNotice{
  position: fixed;
  bottom: 0px;
  background: white;
  padding: 20px;
  border:2px solid #32325d;
}
#cookieNoticeInner{
  margin: 0 auto;
  min-width: 650px;
}
</style>